import { z } from 'zod'
import { CaseStatusEnum } from './case-status-schema'

export const OpinionCitationLinkSchema = z.object({
  citation_mapping_id: z.string().min(1),
  citation_text: z.string().min(1),
  document_type: z.enum(['caselaw', 'lrr']),
  parent_id: z.string().min(1),
  s3_path: z.string().min(1),
  title: z.string().nullable().optional(),
  provider_locator: z.string().min(1).nullable().optional(),
  case_status: z.nativeEnum(CaseStatusEnum).nullable(),
  short_summary: z.string().nullable().optional(),
})

export const OpinionCitationLinksResponseSchema = z.array(OpinionCitationLinkSchema)

export type OpinionCitationLink = z.infer<typeof OpinionCitationLinkSchema>
export type OpinionCitationLinksResponse = z.infer<typeof OpinionCitationLinksResponseSchema>
